export const ElementBoundaryDirective = {
    // /**
    //  *
    //  * @param {HTMLElement} el
    //  * @param {*} binding
    //  * @param {*} vnode
    //  */
    mounted(el, binding) {
        const key = binding.value || "parentOffset"
        const boundary = el.getBoundingClientRect()
        binding.instance[key] = boundary
    },
    /**
     *
     * @param {HTMLElement} el
     * @param {*} binding
     * @param {*} vnode
     */
    updated(el, binding) {
        const key = binding.value || "parentOffset"
        const boundary = el.getBoundingClientRect()
        binding.instance[key] = boundary
        // binding.instance.parentOffset = boundary
    }

}
